import { render, staticRenderFns } from "./LeedCertified.vue?vue&type=template&id=566d0267&"
import script from "./LeedCertified.vue?vue&type=script&lang=ts&"
export * from "./LeedCertified.vue?vue&type=script&lang=ts&"
import style0 from "./LeedCertified.vue?vue&type=style&index=0&id=566d0267&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports